var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1870",
    width: 24,
    height: 24,
    rx: 5,
    fill: "#7ABA56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "back-arrow",
    d: "M11.9832 13.2768L8.20119 9.49285C8.06543 9.36695 7.88612 9.29862 7.70101 9.30224C7.51589 9.30587 7.3394 9.38116 7.20867 9.51227C7.07794 9.64339 7.00317 9.82011 7.0001 10.0052C6.99702 10.1904 7.06588 10.3695 7.19219 10.5048L11.4762 14.7918C11.6061 14.9214 11.781 14.9959 11.9645 14.9998C12.1479 15.0037 12.3258 14.9368 12.4612 14.8128L16.7752 10.5128C16.8417 10.4465 16.8945 10.3678 16.9306 10.281C16.9666 10.1943 16.9853 10.1013 16.9854 10.0074C16.9856 9.91348 16.9672 9.82045 16.9314 9.73362C16.8956 9.64679 16.843 9.56786 16.7767 9.50135C16.7104 9.43483 16.6316 9.38203 16.5449 9.34596C16.4582 9.30989 16.3652 9.29125 16.2712 9.29111C16.1773 9.29097 16.0843 9.30933 15.9975 9.34515C15.9106 9.38096 15.8317 9.43353 15.7652 9.49985L11.9832 13.2768Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreen);
export default __webpack_public_path__ + "static/media/arrow-green.d2e7c5576bc627becc4ec3e55b34365c.svg";
export { ForwardRef as ReactComponent };